module.exports = __webpack_public_path__ + "static/media/GameAudio.c432cf7e.ogg";


//////////////////
// WEBPACK FOOTER
// ./src/audio/GameAudio.ogg
// module id = 477
// module chunks = 0